import React, { useState } from 'react';
import MediaTile from './MediaTile';
import MediaViewer from './MediaViewer';
import { PostMediaItem } from './mediaUtils';

const MAX_TILES = 5;

function gridStyle(shown: number): React.CSSProperties {
  switch (shown) {
    case 2: return { gridTemplateColumns: '1fr 1fr', aspectRatio: '2 / 1' };
    case 3: return { gridTemplateColumns: '1.6fr 1fr', gridTemplateRows: '1fr 1fr', aspectRatio: '16 / 10' };
    case 4: return { gridTemplateColumns: '1fr 1fr', gridTemplateRows: '1fr 1fr', aspectRatio: '16 / 10' };
    default: return { gridTemplateColumns: 'repeat(6, 1fr)', gridTemplateRows: '1.25fr 1fr', aspectRatio: '3 / 2' };
  }
}

function tileStyle(shown: number, i: number): React.CSSProperties | undefined {
  if (shown === 3 && i === 0) return { gridRow: '1 / 3' };
  if (shown === 5) return { gridColumn: i < 2 ? 'span 3' : 'span 2' };
  return undefined;
}

export default function MediaGrid({ postId, items, title }: {
  postId: string
  items: PostMediaItem[]
  title: string
}) {
  const [open, setOpen] = useState<number | null>(null);
  const shown = Math.min(items.length, MAX_TILES);
  const more = items.length > MAX_TILES ? items.length - MAX_TILES : 0;

  return (
    <>
      <div
        className="mb-3 grid w-full gap-[3px] overflow-hidden rounded-xl bg-gray-200"
        style={gridStyle(shown)}
        data-testid="media-grid"
      >
        {items.slice(0, shown).map((item, i) => (
          <MediaTile
            key={`${item.id}:${i}`}
            postId={postId}
            item={item}
            index={i}
            more={i === shown - 1 ? more : 0}
            title={title}
            style={tileStyle(shown, i)}
            onOpen={setOpen}
          />
        ))}
      </div>
      {open !== null && (
        <MediaViewer postId={postId} items={items} title={title} startIndex={open} onClose={() => setOpen(null)} />
      )}
    </>
  );
}
